import * as entertainmentIcon from "images/icons/entertainment-desktop.png"
import * as euIcon from "images/icons/eu-flag.png"
import * as fiveGIcon from "images/icons/five-g-logo.png"
import * as flags77Icon from "images/icons/flags-77-destinations.png"
import * as lightning1Icon from "images/icons/lightning1.png"
import * as lightning2Icon from "images/icons/lightning2.png"
import * as lightning3Icon from "images/icons/lightning3.png"
import * as mailIcon from "images/icons/icon-mail.png"
import * as chatIcon from "images/icons/icon-chat.png"
import * as musicIcon from "images/icons/icon-music.png"
import * as moviesIcon from "images/icons/icon-movies.png"
import * as speedIcon from "images/icons/icon-speed.png"

import btIcon from "images/providerIcons/bticon.png"
import plusnetIcon from "images/providerIcons/plusneticon.png"
import skyIcon from "images/providerIcons/skyicon.png"
import talktalkIcon from "images/providerIcons/talktalkicon.png"
import vodafoneIcon from "images/providerIcons/vodafoneicon.png"
import virginIcon from "images/providerIcons/virginicon.png"
import btplusIcon from "images/providerIcons/btplusicon.png"

// Mapping of icon refs to actual images
const iconMapping = {
  entertainment: entertainmentIcon,
  eu: euIcon,
  "5g": fiveGIcon,
  "77_destinations": flags77Icon,
  boltsX1: lightning1Icon,
  boltsX2: lightning2Icon,
  boltsX3: lightning3Icon,
  mail: mailIcon,
  chat: chatIcon,
  music: musicIcon,
  movies: moviesIcon,
  speed: speedIcon,
  BT: btIcon,
  Plusnet: plusnetIcon,
  Virgin: virginIcon,
  Vodafone: vodafoneIcon,
  TalkTalk: talktalkIcon,
  Sky: skyIcon,
  BTPlus: btplusIcon
}

export const iconFromName = iconRef => {
  return iconMapping[iconRef]
}

// export const REFS = {
//   ENTERTAINMENT: "entertainment",
//   EU: "eu",
//   "5g": "5g",
//   "77_DESTINATIONS"
// }
